import type { CSSProperties, MouseEvent } from 'react';

import FrontDoor from '@cartwhl/ui/feature/FrontDoor';
import CrossIcon from '@cartwhl/ui/icons/CrossIcon';

import type { AssetLibraryEmbedConfig } from '../assetLibraryEmbedConfig';
import LibraryPageContent from './LibraryPageContent';

export interface AssetLibraryModalProps {
  maxWidth?: number;
  panelStyle?: CSSProperties;
  closeLabel?: string;
  embedConfig?: AssetLibraryEmbedConfig;
  onClose: () => void;
}

const DEFAULT_MAX_WIDTH = 1116;

export default function AssetLibraryModal({
  maxWidth = DEFAULT_MAX_WIDTH,
  panelStyle,
  closeLabel = 'Close',
  embedConfig,
  onClose,
}: AssetLibraryModalProps) {
  const resolvedPanelStyle: CSSProperties = {
    maxWidth: `${maxWidth}px`,
    ...panelStyle,
  };
  const isMediaPicker = Boolean(embedConfig?.mediaSelection);

  const stopClickPropagation = (event: MouseEvent) => {
    event.stopPropagation();
  };

  return (
    <div
      className="flex min-h-0 w-full flex-1 flex-col self-center"
      style={resolvedPanelStyle}
      onClick={stopClickPropagation}
      onMouseDown={stopClickPropagation}
    >
      <LibraryPageContent embedded embedConfig={embedConfig ?? null} />
      {!isMediaPicker ? (
        <div className="flex shrink-0 justify-center pt-2">
          <FrontDoor.Button
            variant="tertiary"
            text={closeLabel}
            icon={<CrossIcon className="h-4 w-4" />}
            onClick={onClose}
            className="min-w-[128px]"
            rounded="both"
          />
        </div>
      ) : null}
    </div>
  );
}
